var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import moment from 'moment';

import { getGaDefaultDimension, getGaDefaultMetric, getGaDateRanges, getDimensionNames, getMetricNames, getMetricTypeByName } from "./gaV4";

export function getGaBarByDimension() {
    var report = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var metric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var dimension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;


    if (!report) {
        return {
            error: "no report"
        };
    }

    // get defaults

    if (!dimension) {
        dimension = getGaDefaultDimension(report);
    }

    if (!metric) {
        metric = getGaDefaultMetric(report);
    }

    // get dateRanges

    var dateRanges = getGaDateRanges(report);

    if (!dateRanges) {
        return {
            error: "No dateRanges"
        };
    }

    // get unique series by dateRange and dimensions

    var rows = report.data.rows;


    var series = {};

    var dimensionNames = getDimensionNames(report);
    var metricNames = getMetricNames(report);
    var metricType = getMetricTypeByName(report, metric);

    dateRanges.map(function (range, index) {

        rows.map(function (row, index) {

            var serie = {};
            var serieId = [];

            serieId.push(range.startDate);
            serieId.push(range.endDate);

            // get dimensions + x

            row.dimensions.map(function (dValue, dIndex) {
                var dName = dimensionNames[dIndex];

                serieId.push(dValue);

                if (dName === dimension) {
                    serie.x = dValue;
                }

                serie[dName] = dValue;
            });

            var values = row.metrics[range.id].values;


            values.map(function (mValue, mIndex) {
                var mName = metricNames[mIndex];

                if (mName === metric) {
                    serie.y = parseFloat(mValue);
                }
            });

            // get datetime

            if (dimension === "ga:nthMinute" && serie[dimension]) {
                serie.datetime = moment(range.startDate).add(serie[dimension], 'minutes').format();
            }

            if (dimension === "ga:nthHour" && serie[dimension]) {
                serie.datetime = moment(range.startDate).add(serie[dimension], 'hours').format();
            }

            if (dimension === "ga:nthDay" && serie[dimension]) {
                serie.datetime = moment(range.startDate).add(serie[dimension], 'days').format();
            }

            if (dimension === "ga:nthWeek" && serie[dimension]) {
                serie.datetime = moment(range.startDate).add(serie[dimension] * 7, 'days').startOf('week').format();
            }

            if (dimension === "ga:nthMonth" && serie[dimension]) {
                serie.datetime = moment(range.startDate).add(serie[dimension] * 7, 'days').startOf('month').format();
            }

            // id

            var id = serieId.join('-');

            // push serie to series

            if (!series[id]) {
                series[id] = serie;
            }
        });
    });

    var data = {};
    var keys = [];

    Object.values(series).map(function (serie, index) {
        var x = serie.x,
            y = serie.y;


        if (!data[x]) {
            data[x] = {
                id: x
            };
        }

        // multidimension

        Object.keys(serie).map(function (key, index) {

            if (key === "x" || key === "y" || key === "datetime" || key === dimension) {
                return null;
            }

            var value = serie[key];

            if (!keys.includes(value)) {
                keys.push(value);
            }

            data[x][value] = y;
        });

        // single dimension

        if (!data[x].value) {
            data[x].value = y;
        }
    });

    // if no keys, use value as key

    if (!keys.length) {
        keys = ["value"];
    }

    return _extends({}, dateRanges[0], {
        xFormat: "STRING",
        yFormat: metricType,
        metric: metric,
        dimension: dimension,
        data: Object.values(data),
        keys: keys
    });
}